import { FC } from "react";

import { ICoordinate } from "shared/types";
import { MutedDarkText, TinyText } from "shared/styles";
import { Spacer } from "shared/layout";
import { StyledPopup, PopupTitle } from "./styles";

export interface IMapPopup {
  title: string;
  subTitle?: string;
}

export interface PopupProps extends IMapPopup {
  coordinates: ICoordinate;
}

export const MapPopup: FC<PopupProps> = ({ title, subTitle, coordinates }) => {
  return (
    <StyledPopup
      {...coordinates}
      offsetTop={-40}
      tipSize={0}
      closeOnClick={false}
      closeButton={false}
      dynamicPosition={false}
    >
      <Spacer size="xs">
        <PopupTitle>{title}</PopupTitle>
        <MutedDarkText as={TinyText}>{subTitle}</MutedDarkText>
      </Spacer>
    </StyledPopup>
  );
};
